<template>
    <div class="tpl-content-wrapper ">
        <ConfirmDialog :title="'确认删除本条数据?'" :content="''" :show="show_confirm_dialog"
                       :buttons="buttons"
                       @cancel="close_confirm_dialog" @close_dialog="close_confirm_dialog"
                       @confirm="delete_post($event)"></ConfirmDialog>
        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>发表记录</span>
                    <span class="desc">点击“发表”发布新的记录</span>
                    <router-link class="btn"
                                 style="background-color: #66CCFF;margin-top: -7px;margin-left: 50px;color:white"
                                 tag="a" :to="{ name: 'post_publish'}">发表
                    </router-link>
                </div>
            </div>
            <div class="tpl-portlet-content">
                <div class="qa_item_div" v-for="post in display_posts" :key="post['id']">
                    <div class="qa_item_question_div">
                        <router-link tag="a" :to="{ name: 'user', params: { id: post.author.id } }">
                            <img :src="post.author.avatar_url"
                                 class="item_question_avatar"/>
                        </router-link>
                        <div class="item_question">
                            <router-link :to="{ name: 'post', params: { id: post.number } }" tag="a"
                                         class="item_question_title">
                                {{post.title}}
                            </router-link>
                            <div class="item_question_content" v-if="post.content_description.length<=100">
                                {{post.content_description}}
                            </div>
                            <div class="item_question_content" v-else>
                                {{post.content_description.substring(0,100)}}......
                            </div>
                            <div class="item_question_base_info">
                                <!--  -->
                                <span class="margin-right-10"> {{post.author.name}}</span>
                                <!--<span class="level margin-right-10">L{{post.author.level}}</span>-->
                                <span class="margin-right-10">{{post.created_at}}</span>
                                <span class="margin-right-10">发布于</span>
                                <span style="color: #66CCFF" class="margin-right-10">{{post.column.display_name}}</span>
                                <span style="color: #00965e" class="margin-right-10" v-for="tag in post.tags" :key="tag['id']">{{tag.name}}</span>
                                <!--<span>-->
                                <!--最后回复 dsasa-->
                                <!--<span class="level">L5</span>-->
                                <!--</span>-->
                            </div>
                        </div>
                    </div>
                    <p v-if="post.is_published" class="pubilshed_type_p pubilshed">已发布</p>
                    <p v-else class="pubilshed_type_p no-pubilshed">未发布</p>
                    <div class="item_view_answer_div">
                        <div class="view_answer_div answer_number_div" style="margin-top: 10px;">
                            <span class="view_span view_answer_span">{{post.comments_count}}</span>
                            <span class="view_span view_answer_span">回复</span>
                        </div>
                        <div class="view_answer_div view_number_div" style="margin-top: 10px;">
                            <span class="answer_span view_answer_span">{{post.views}}</span>
                            <span class="answer_span view_answer_span">查看</span>
                        </div>

                        <div class="view_answer_div view_number_div">
                            <a v-if="post.is_published" class="answer_span view_answer_span"
                               @click="change_publish_state(post.id,'do_cancel')"
                               style="text-decoration: underline;color: #66CCFF">取消</a>
                            <a v-else class="answer_span view_answer_span"
                               @click="change_publish_state(post.id,'do_publish')"
                               style="text-decoration: underline;color: #66CCFF">发布</a>
                            <div @click="set_active_column_id(post.column_id)">
                                <router-link tag="a"
                                             :to="{ name: 'post_edit',params: { id: post.number}}"
                                             class="answer_span view_answer_span"
                                             style="text-decoration: underline;color: #66CCFF">编辑
                                </router-link>
                            </div>
                            <a class="answer_span view_answer_span" @click="to_delete_post(post.id)"
                               style="text-decoration: underline;color: #66CCFF">删除</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ConfirmDialog from '@/components/common_components/dialog/confirm_dialog.vue'
    import postApi from '@/api/post/post.js'
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        name: "learning_main",
        data: function () {
            return {
                show_confirm_dialog: false,
                buttons: []
            }
        },
        components: {
            ConfirmDialog
        },
        computed: {
            ...mapState({
                active_column_id: state => state.post.active_column_id,
                display_posts_params: state => state.post.display_posts_params,
            }),
            ...mapGetters({
                display_posts: 'post/display_posts',
                // my_weblogs_posts: 'post/my_weblogs_posts',
                // my_moments_posts: 'post/my_moments_posts'
            }),
        },
        methods: {
            ...mapActions({
                get_my_posts: 'post/get_my_posts',
                delete: 'post/delete_post',
                change_display_posts_params: 'post/change_display_posts_params',
                change_post: 'post/change_post',
                change_active_column_id: 'post/change_active_column_id',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            to_delete_post(post_id) {
                this.buttons = [{
                    'name': '取消',
                    'method': 'cancel',
                    'params': {},
                    'style': 'button-primary button-default'
                }, {'name': '确定', 'method': 'confirm', 'params': {'post_id': post_id}, 'style': 'button-primary'}]
                this.open_confirm_dialog()
            },
            open_confirm_dialog() {
                this.show_confirm_dialog = true
            },
            close_confirm_dialog() {
                this.show_confirm_dialog = false
            },
            async change_publish_state(post_id, action) {
                let vals = {
                    post_id: post_id,
                    is_published: false,
                }
                if (action === 'do_publish') {
                    vals.is_published = true
                }
                let res = await postApi.modify_post_publish_state(vals)
                let data = JSON.parse(res.data.result);
                this.change_warning_message(data.message);
                if (data.code === 'success') {
                    this.change_warning_bar_style_class('success');
                    this.change_post(data.post)
                } else {
                    this.change_warning_bar_style_class('alert');
                }
            },
            delete_post(params) {
                this.delete(params).then((response) => {
                    let data = response.data;
                    this.change_warning_message(data.message);
                    if (data.code === 'success') {
                        this.change_warning_bar_style_class('success');
                        this.close_confirm_dialog()
                    } else {
                        this.change_warning_bar_style_class('alert');
                    }
                })
            },
            set_active_column_id(column_id) {
                this.change_active_column_id(column_id)
            }
        },
        mounted() {
            this.get_my_posts()
        }
    }
</script>

<style scoped>
    .tpl-portlet-content {
        height: 455px;
        overflow: auto
        /*background: red;*/
    }

    .item_question_content {
        line-height: 24px;
        margin-top: 11px;
    }

    .qa_item_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eee;
    }

    .qa_item_question_div {
        display: flex;
        width: 83%;
    }

    .item_question {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        max-width: 83%;
        /*max-width: 600px;*/
    }

    .item_question_avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: 15px;
        margin-top: 20px;
    }

    .item_question_title {
        display: inline-block;
        white-space: nowrap;
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #0181da;
        max-width: 100%;
        font-weight: bold
    }

    .item_question_base_info {
        margin-top: 8px;
        font-size: 13px;
        color: #9b9da2;
    }

    .item_view_answer_div {
        display: flex;
        width: 16%;
        /*margin: 0 30px;*/
        padding: 0 15px;
        justify-content: space-around;
    }

    .view_answer_div {
        display: flex;
        flex-direction: column;
        /*margin-right: 5px;*/
    }

    .view_answer_span {
        font-size: 14px;
        text-align: center;
    }

    .view_span {
        color: #6CF;
    }

    .level {
        color: #ffc500;
    }

    .pubilshed_type_p {
        min-height: 32px;
        width: 80px;
        margin-top: 17px;
        color: #fff;
        padding: 7px 17px;
        border-radius: 100px;
    }

    .pubilshed {
        background: #59cf4a;
    }

    .no-pubilshed {
        background: #f5c6cb;
    }

    .margin-right-10 {
        margin-right: 10px;
    }

</style>